import React from 'react';
export const StatsBar = () => {
  return <div className="border-y border-legal-700 bg-legal-800/50 py-8" data-id="element-269">
      <div className="container mx-auto px-4" data-id="element-270">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-4 text-center divide-x-0 md:divide-x divide-legal-700" data-id="element-271">
          <div className="flex flex-col items-center justify-center" data-id="element-272">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-273">+500</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-274">
              Abogados confían
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-275">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-276">10</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-277">
              Módulos completos
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-278">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-279">5</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-280">
              Bonos premium
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-281">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-282">2026</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-283">
              Actualizado
            </span>
          </div>
          <div className="flex flex-col items-center justify-center col-span-2 md:col-span-1" data-id="element-284">
            <span className="text-3xl mb-1" data-id="element-285">🇦🇷</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-286">
              Todo el país
            </span>
          </div>
        </div>
      </div>
    </div>;
};